import { gql } from "@apollo/client";

export const LINK_TELEGRAM_ACCOUNT = gql`
  mutation LinkTelegramAccount($input: LinkTelegramInput!) {
    linkTelegramAccount(input: $input) {
      success
      message
      error
    }
  }
`;

export const CREATE_TELEGRAM_ACCOUNT = gql`
  mutation CreateTelegramAccount($input: CreateTelegramAccountInput!) {
    createTelegramAccount(input: $input) {
      success
      token
      user {
        id
        role
        name
        telegramId
      }
      isNewUser
      needsOnboarding
      error
    }
  }
`;

export const LINK_TELEGRAM_GOOGLE = gql`
  mutation LinkTelegramGoogle($input: LinkTelegramGoogleInput!) {
    linkTelegramGoogle(input: $input) {
      success
      token
      user {
        id
        role
        name
        telegramId
      }
      isNewUser
      error
    }
  }
`;

export const LINK_TELEGRAM_SMS = gql`
  mutation LinkTelegramSms($input: LinkTelegramSmsInput!) {
    linkTelegramSms(input: $input) {
      success
      token
      user {
        id
        role
        name
        telegramId
      }
      isNewUser
      error
    }
  }
`;

export const REQUEST_SMS_CODE = gql`
  mutation RequestSmsCode($input: RequestSmsCodeInput!) {
    requestSmsCode(input: $input) {
      success
      message
      data {
        status
      }
    }
  }
`;
